var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4026",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40967",
    "data-name": "Group 40967",
    transform: "translate(9396 23039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15551",
    "data-name": "Rectangle 15551",
    width: 24,
    height: 24,
    transform: "translate(-9396 -23039)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4020",
    transform: "translate(-9394.5 -23037.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4024",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4030",
    transform: "translate(10.5 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4032",
    d: "M0-311.448H3.523a1.608,1.608,0,0,0-.146,1.333,1.649,1.649,0,0,0,1.229,1.1,1.649,1.649,0,0,0,1.984-1.614,1.63,1.63,0,0,0-.228-.824H9.885v-8.237a1.647,1.647,0,0,0-1.647-1.647H0",
    transform: "translate(0 321.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4034",
    transform: "translate(0.615 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4036",
    d: "M-311.448-311.448v-3.523a1.608,1.608,0,0,0,1.333.146,1.649,1.649,0,0,0,1.1-1.229,1.649,1.649,0,0,0-1.614-1.984,1.63,1.63,0,0,0-.824.229v-3.523h-8.237a1.647,1.647,0,0,0-1.647,1.647v8.237",
    transform: "translate(321.333 321.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4038",
    transform: "translate(0.615 8.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4040",
    d: "M-311.448-77.862h-3.523a1.608,1.608,0,0,0,.146-1.333,1.649,1.649,0,0,0-1.229-1.1,1.649,1.649,0,0,0-1.984,1.614,1.63,1.63,0,0,0,.229.824h-3.523v8.237a1.647,1.647,0,0,0,1.647,1.647h8.237",
    transform: "translate(321.333 80.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4042",
    transform: "translate(8.029 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4044",
    d: "M-77.863,0V3.523A1.608,1.608,0,0,0-79.2,3.377a1.649,1.649,0,0,0-1.1,1.229A1.649,1.649,0,0,0-78.686,6.59a1.63,1.63,0,0,0,.824-.228V9.885h8.237a1.647,1.647,0,0,0,1.647-1.647V0",
    transform: "translate(80.334)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.92f067d75f3f991e82adab55d5b7631c.svg";
export { ForwardRef as ReactComponent };